'use client'

import { Suspense, useMemo, type ComponentProps } from 'react'

import { usePathname } from 'next/navigation'

import { documentPath } from '@/lib/seo/document-path'
import { hasRelativeHtmlLinks, htmlLinkRel } from '@/lib/seo/html-link-rel'

import { useIndexingPolicy } from './indexing-provider'

type Props = ComponentProps<'div'>

const ResolvedHtml = ({ dangerouslySetInnerHTML, documentUrl, ...props }: Props & { documentUrl?: string }) => {
  const policy = useIndexingPolicy()
  const source = String(dangerouslySetInnerHTML?.__html ?? '')
  const html = useMemo(() => htmlLinkRel(source, policy, documentUrl), [source, policy, documentUrl])
  return <div {...props} dangerouslySetInnerHTML={{ __html: html }} />
}

const RelativeHtml = (props: Props) => <ResolvedHtml {...props} documentUrl={documentPath(usePathname())} />

export const IndexingHtml = (props: Props) => {
  if (hasRelativeHtmlLinks(String(props.dangerouslySetInnerHTML?.__html ?? ''))) {
    return (
      <Suspense fallback={<ResolvedHtml {...props} />}>
        <RelativeHtml {...props} />
      </Suspense>
    )
  }
  return <ResolvedHtml {...props} />
}
